export default __webpack_public_path__ + "static/media/logo.593947d4.png";